module.exports = __webpack_public_path__ + "img/minip_app_image_ocr.890a2362.png";